import useSWR from "swr"
import { FailedDeliveryApi } from "../../../apis"

export function useExceptionsByDnQuery(deliveryNoteId: string | null | undefined) {
  return useSWR(
    deliveryNoteId ? ["dn-exceptions", deliveryNoteId] : null,
    async () => FailedDeliveryApi.listByDn(deliveryNoteId as string),
    { revalidateOnFocus: false },
  )
}
